import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=a024ec8e&"
import script from "./Role.vue?vue&type=script&lang=ts&"
export * from "./Role.vue?vue&type=script&lang=ts&"
import style0 from "./Role.vue?vue&type=style&index=0&id=a024ec8e&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports